import { frontendURL } from 'dashboard/helper/URLHelper';
import SponsoredPages from './sponsored/index.vue';
import FeedPages from './././feed/index.vue';
import ReelPages from '././reels/index.vue';
import MentionPages from '././mentions/index.vue';
import SponsoredPosts from './sponsored/posts.vue';
import ReelPosts from '././reels/posts.vue';
import FeedPosts from './././feed/posts.vue';
import MentionPosts from './././mentions/posts.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CommentsModerationListView from './CommentsModerationList.vue';
import PostCommentsListView from './PostCommentsList.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/moderation'),
    children: [
      {
        path: 'comments',
        name: 'comments_moderation',
        component: CommentsModerationListView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/feed'),
    children: [
      {
        path: '',
        name: 'feed',
        component: FeedPages,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts',
        name: 'feed_posts',
        component: FeedPosts,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts/:post_id',
        name: 'feed_posts_comments',
        component: PostCommentsListView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/sponsored'),
    children: [
      {
        path: '',
        name: 'sponsored',
        component: SponsoredPages,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts',
        name: 'sponsored_posts',
        component: SponsoredPosts,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts/:post_id',
        name: 'sponsored_posts_comments',
        component: PostCommentsListView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/reels'),
    children: [
      {
        path: '',
        name: 'reels',
        component: ReelPages,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts',
        name: 'reel_posts',
        component: ReelPosts,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts/:post_id',
        name: 'reel_posts_comments',
        component: PostCommentsListView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/mentions'),
    children: [
      {
        path: '',
        name: 'mentions',
        component: MentionPages,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts',
        name: 'mention_posts',
        component: MentionPosts,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
      {
        path: ':page_id/posts/:post_id',
        name: 'mention_posts_comments',
        component: PostCommentsListView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
        },
      },
    ],
  },
];
